<template>
  <div
    v-bind="$attrs"
    :class="`icon ${size}`"
    :style="{
      'mask-image': `url(${iconUrl})`,
      'mask-repeat': 'no-repeat',
      'mask-position': 'center',
      'mask-size': 'contain',
      display: 'inline-block'
    }"
    @click="$emit('click')"
  />
</template>
<script>
export default {
  name: 'Icon',
  props: {
    name: {
      value: String,
      default: ''
    },
    size: {
      value: String,
      default: 'md'
    }
  },
  computed: {
    iconUrl() {
      try {
        return require(`@/assets/images${this.name}`)
      } catch (e) {
        console.error('SVG not found:', this.iconName)
        return ''
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import './icon';
</style>
